import { Link } from "react-router-dom";
import VisibilityToggle from "src/Components/Shared/VisibilityToggle/VisibilityToggle";
import EndPoints from "src/Constants/EndPoints";
import useApiMutation from "src/Hooks/Shared/useApiMutation";
import AppStateHandler from "src/StateHandlers/AppStateHandler";
import { useTranslation } from "react-i18next";

function Group(props: any) {
  const { user } = AppStateHandler.getState();
  const { t, i18n } = useTranslation();
  const {
    setGroupData,
    setModalVisibility,
    refetch,
    ...item
  } = props;
  const {
    id,
    group_icon,
    title,
    total_members,
    is_private,
    is_requested,
  } = item;
  const detailViewHandler = () => {
    setGroupData(item);
  };

  const [joinGroup, { status }] = useApiMutation({
    onSettled: refetch,
  });

  const joinHandler = (e: any) => {
    e.preventDefault();
    if (status === "loading") {
      return;
    }
    joinGroup({
      url: EndPoints.joinGroup,
      data: {
        subId: user?.username,
        groupId: id,
      },
    });
  };

  const requestedBtn = {
    backgroundColor: "#fff",
    color: "#8dd400",
    borderRadius: "30px",
    border: "1px solid #8dd400",
  };

  return (
    <Link to={"/groups/" + item.id}>
      <div className="cursor-pointer">
        <div className={`d-flex justify-content-between position-relative ${i18n.dir()==='rtl'?'pr-5':'pl-5'}`}>
          <div className={`message_user_icon ${i18n.dir()==='rtl'?'message_user_icon_posRTL':'message_user_icon_posLTR'}`} onClick={detailViewHandler}>
            <img
              src={group_icon}
              className="rounded-circle object_fit"
              width="40"
              height="40"
              alt=""
            />
          </div>
          <h4
            className={`fz16 mb-1 ${i18n.dir()==='rtl'?'pr-3 text-right':'pl-3'} mb-0 poppinssemibold`}
            onClick={detailViewHandler}
          >
            {title} <br />
            <span className={`fz10 text-secondary ${i18n.dir() === "rtl" ? "Almaraisemibold":"poppinsregular"}`}>
              {total_members} {t("Members")}
            </span>
          </h4>
          <div>
            {is_requested && is_private ? (
              <button
                className="btn fz14  p12-40"
                style={requestedBtn}
                onClick={detailViewHandler}
              >
                {t("Join")}
              </button>
            ) : <></>}
            {is_private && !is_requested ? (
              <button
                className="btn custom_btn fz14  p12-40"
                onClick={detailViewHandler}
              >
                {t("Join")}
              </button>
            ) : <></>}
            {!is_private && !is_requested ? (
              <button
                className={
                  "btn fz14  p12-40 custom_btn"
                }
                onClick={joinHandler}
              >
                <VisibilityToggle visible={status === "loading"}>
                  <span className="spinner-border spinner-border-sm"></span>
                </VisibilityToggle>
                {t("Join")}
              </button>
            ) : <></>}
          </div>
        </div>
        <hr />
      </div>
    </Link >
  );
}

export default Group;
